export enum DocumentStepEnum {
  InitiateChange = 0,
  GenerateDocuments = 1,
  SignDocuments = 2,
  AsicResponse = 3,
}
